/**
 *    @author: Andrew Sheen
 *    @since:  2020-12-20
 */

import { Component, OnInit, ViewEncapsulation} from '@angular/core';
import { Router } from '@angular/router';
import { TimerService } from 'src/refresh/service/timer-service';
import { FormBaseComponent } from '../_common/component/form-base.component';
import { Path } from  "../_common/constant/page-const";
import { InputData } from '../_common/data/input-data';
import { StartValidation } from './start.validator';

@Component({ 
      selector: 'start',
      templateUrl: './start.component.html',
      styleUrls: ['./start.component.less'],
      encapsulation: ViewEncapsulation.None
})
export class StartComponent extends FormBaseComponent implements OnInit{

       public isMSIE:boolean;
       
       constructor( public router: Router,public timerService:TimerService, public data:InputData) {
                    super(router,timerService);  
                    super.setNextPage(Path.BeforeYouBegin,null);
                    super.setValidator(new StartValidation(this));

                    data.subject.showHeader = true;

                    this.isMSIE = /msie\s|trident\//i.test(window.navigator.userAgent)
                    console.log("compatable",!this.isMSIE);

                    InputData.currentPageIdx = 1;
                    if ( InputData.moveNext == 0 || InputData.moveNext == InputData.currentPageIdx ) this.timerService.isForwarding = false;
       }

       public ngOnInit() {
              super.forwardNext(this.data.eligibility.listedParentCount);
       }


       public onNextClick() : boolean {

              if ( this.isMSIE ) {
                   window.scrollTo(0, 0);
                   return;
              }

              this.data.subject.showHeader = false;

              if ( this.data.subject.hasError ) {

                  let  href = window.location.href;
                  let  url = href;
                  let idx = url.lastIndexOf("/IBR");
                  if ( idx > 0 ) {
                       url = url.substring(0,idx+4) +"/receipt/index.html?error&";
                  }
      
                  let lang = this.data.subject.language;

                  if ( "fr" == lang ) lang = 'F';
                  else                lang = 'E';
      
                  url += lang;
      
                  window.open(url);
                  return;
              }

              return super.onNextClick();
       }

       public onClick() {
       }
}
